import { AcceptedBetModel } from "../AcceptedBetModel";
import { EventErrorModel } from "../EventErrorModel";
import { observable } from "mobx";

export class BetPlacementModel {
    eventId: number;
    @observable status: number;
    error: EventErrorModel;
    success: AcceptedBetModel;

    constructor(source: BetPlacementModel) {
        this.eventId = source.eventId;
        this.status = source.status;
        this.error = source.error;
        this.success = source.success;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./blocks/PulseBetMarkets/data/BetPlacementModel/BetPlacementModel.ts